/**
 * Paths reachable without a session. Single source of truth for the edge
 * middleware (apps/web/middleware.ts) and the client AuthProvider
 * (src/components/auth/auth-provider.tsx).
 *
 * The landing page, login, the ecosystem-reports coming-soon page (which the
 * landing links to) and the blog are public. The blog is published to be read
 * and shared by people who have no account, so /blog and every post under it
 * must stay reachable. The password-reset pages are reached by people who
 * cannot sign in. Search is admin-only: the edge requires a session and
 * AdminOnlyRoute enforces the admin role client-side.
 *
 * Edge runtime: plain constants and a pure function only, no Node imports.
 */
export const PUBLIC_PATHS = [
  "/",
  "/login",
  "/reports",
  "/blog",
  "/forgot-password",
  "/reset-password",
];

/** Exact match, or a subpath of a non-root public path (e.g. /blog/post). */
export function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATHS.some(
    (p) => pathname === p || (p !== "/" && pathname.startsWith(`${p}/`)),
  );
}
